import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Check } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function Pricing() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubscribe = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      toast.error('Please login first');
      navigate('/login');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${BACKEND_URL}/api/payments/checkout`,
        { origin_url: window.location.origin },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      window.location.href = response.data.url;
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to initiate checkout');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen" style={{background: '#0a0a0a'}}>
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-16">
        <div className="flex justify-between items-center mb-12">
          <h1 className="text-2xl font-bold" style={{fontFamily: 'Outfit', color: '#f59e0b'}}>AIPedia</h1>
          <Button variant="ghost" onClick={() => navigate('/dashboard')} data-testid="nav-dashboard-btn">
            Back to Dashboard
          </Button>
        </div>

        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{fontFamily: 'Outfit'}}>Simple Pricing</h2>
          <p className="text-lg text-muted-foreground">Unlock unlimited access to all premium AI prompts</p>
        </div>

        <div className="max-w-md mx-auto">
          <Card className="border-primary" data-testid="pricing-card">
            <CardHeader>
              <CardTitle className="text-3xl" style={{fontFamily: 'Outfit'}}>Pro Membership</CardTitle>
              <CardDescription>
                <span className="text-4xl font-bold" style={{color: '#f59e0b'}}>£1.99</span>
                <span className="text-muted-foreground">/month</span>
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 mt-0.5" style={{color: '#f59e0b'}} />
                  <span>Unlimited access to all prompts</span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 mt-0.5" style={{color: '#f59e0b'}} />
                  <span>Daily new prompt additions</span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 mt-0.5" style={{color: '#f59e0b'}} />
                  <span>7 curated categories</span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 mt-0.5" style={{color: '#f59e0b'}} />
                  <span>Search and filter functionality</span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 mt-0.5" style={{color: '#f59e0b'}} />
                  <span>Cancel anytime</span>
                </li>
              </ul>
              <Button 
                className="w-full" 
                size="lg" 
                onClick={handleSubscribe}
                disabled={loading}
                data-testid="subscribe-btn"
              >
                {loading ? 'Processing...' : 'Subscribe Now'}
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
